{
  "jira.jira-notify-reaction.message-template.text.single-reaction-with-name": ":bell: *{userName} ha reaccionado a tu comentario*",
  "jira.jira-notify-reaction.message-template.text.view-comment": "Ver comentario"
}